import Image from 'next/image';
import React from 'react';
import Link from 'next/link';
import { HeaderContainer } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderContainer';
import { appConfig } from 'utils/app.config';
import { Tiny1 } from 'components/Typography';
import { ConnectInfoButton } from 'components/Header/ConnectInfoButton';
import { MENU } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderCommon/menu';
import { Button } from 'structure/home/components/Button';
import { headerStatus } from 'interfaces/header-status.enum';
import { useTranslation } from 'react-i18next';
import { getStaticAssetUrl } from 'utils/url';

export const HeaderCommonDesktop = ({
  isBannerClosed,
}: {
  isBannerClosed?: boolean;
}) => {
  return (
    <div
      className={`fixed flex h-24 items-center border-b border-customBorder max-lg:border-b-0 ${!appConfig.featureFlags.ENABLE_BANNER || isBannerClosed ? 'top-0' : 'top-8'} z-20 w-full bg-box-primary`}
    >
      <HeaderContainer className='relative mx-auto flex flex-row items-center'>
        <Link href='/'>
          <Image
            className='h-[70px]'
            alt='Singularity Finance'
            src={getStaticAssetUrl(
              '/sfi/static/logo/singularity_finance_full_logo.svg'
            )}
            width={209}
            height={50}
          />
        </Link>
        <div className='ml-auto flex flex-row items-center gap-5 lg:gap-[2.5rem] xl:gap-[2.5rem]'>
          <DesktopMenu />
          <ConnectInfoButton />
        </div>
      </HeaderContainer>
    </div>
  );
};

const DesktopMenu = () => {
  const { t } = useTranslation('common');
  return (
    <div className='ml-auto flex flex-row items-center gap-5 lg:gap-[2.5rem] xl:gap-[2.5rem]'>
      {MENU?.filter((item) => item.visible)?.map((item, index) => (
        <Button
          key={index}
          className={`p-0 text-base ${item.status === headerStatus.COMING_SOON && 'pointer-events-none'}`}
          style='link'
          size='unspecified'
          component={Link}
          href={item.href}
          target={item?.target}
        >
          {item.title}
          {item.status && (
            <Tiny1 className='ps-1 text-[#EDFF6D]'>
              {' '}
              {t('LINK_STATUS.' + item.status)}
            </Tiny1>
          )}
        </Button>
      ))}
    </div>
  );
};
